import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MarkdownPipe } from 'ngx-markdown';
import { NgScrollbarModule } from 'ngx-scrollbar';

@Component({
  selector: 'scraped-page-preview',
  templateUrl: './scraped-page-preview.component.html',
  styleUrls: ['./scraped-page-preview.component.scss'],
  imports: [CommonModule, NgScrollbarModule, MarkdownPipe]
})
export class CharlaScrapedPagePreviewComponent {
  @Input() scraped_page: string;

  constructor(public activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.close();
  }
}
